import { Crisp } from "crisp-sdk-web";

const CRISP_WEBSITE_ID = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID;

let configured = false;

export const isCrispEnabled = () => Boolean(CRISP_WEBSITE_ID);

export const configureCrisp = () => {
  if (!CRISP_WEBSITE_ID || configured) {
    return;
  }

  Crisp.configure(CRISP_WEBSITE_ID, { autoload: false });
  configured = true;
};

export interface CrispUserIdentity {
  id: string;
  name: string;
  email: string;
  organisationName?: string;
  namespaceName?: string;
}

export const identifyCrispUser = (user: CrispUserIdentity) => {
  if (!isCrispEnabled()) {
    return;
  }
  configureCrisp();

  Crisp.setTokenId(user.id);
  Crisp.user.setEmail(user.email);
  Crisp.user.setNickname(user.name);
  Crisp.session.setData({
    user_id: user.id,
    organisation: user.organisationName ?? "",
    namespace: user.namespaceName ?? "",
  });
};

export const resetCrispSession = () => {
  if (!isCrispEnabled()) {
    return;
  }

  Crisp.setTokenId();
  Crisp.session.reset();
};

// Safety net so the button never spins forever if the `session:loaded` event
// never arrives (e.g. the Crisp script is blocked or the network is down).
const SESSION_LOAD_TIMEOUT_MS = 10_000;

export const openSupportChat = (message: string): Promise<void> =>
  new Promise(resolve => {
    if (!isCrispEnabled()) {
      resolve();
      return;
    }
    configureCrisp();

    let settled = false;
    const openAndSend = () => {
      if (settled) {
        return;
      }
      settled = true;
      Crisp.session.offLoaded();
      Crisp.chat.open();
      Crisp.message.send("text", message);
      resolve();
    };

    // Already loaded from a previous click: open immediately.
    if (Crisp.isCrispInjected()) {
      openAndSend();
      return;
    }

    Crisp.session.onLoaded(openAndSend);
    Crisp.load();
    setTimeout(openAndSend, SESSION_LOAD_TIMEOUT_MS);
  });
